import React from 'react'
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

// components
import {LangController} from "../../../components/tabs/langController";

// labels
import {FL_BODY, FL_TITLE} from "../../../components/i18n/formLabels";
import {PH_BODY, PH_TITLE} from "../../../components/i18n/placeHolders";

// hooks
import useParamSetting from "../../../hooks/useParamSetting";

const NotificationLangs = props => {
    const { paramSetting = {}, loading } = useParamSetting('notification_max_character', true)
    const notificationConfig = JSON.parse(paramSetting?.ps_value_max || '{}')
    

    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id    : '',
            lang  : { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title : '',
            body  : '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <Row>
        <Col md="12">
            <FormGroup>
                <Label>{FL_TITLE}</Label>
                <Input
                    type="text"
                    name="title"
                    placeholder={PH_TITLE}
                    value={child.title}
                    maxLength={notificationConfig?.title}
                    onChange={e => onInputChange(e, child.lang)}
                    disabled={disableInputs}
                />
                <div
                    className={`pull-right ${ child?.title.length >= notificationConfig?.title && 'label-is-invalid'}`}>
                    {!loading && <> {child?.title.length} / {notificationConfig?.title}  </>}
                </div>
            </FormGroup>
        </Col>
        <Col md="12">
            <FormGroup>
                <Label>{FL_BODY}</Label>
                <Input
                    type="textarea"
                    name="body"
                    placeholder={PH_BODY}
                    value={child.body}
                    maxLength={notificationConfig?.body}
                    onChange={e => onInputChange(e, child.lang)}
                    disabled={disableInputs}
                />
                <div
                    className={`pull-right ${child?.body.length >= notificationConfig?.body  && 'label-is-invalid'}`}>
                    {!loading && <> {child?.body.length} / {notificationConfig?.body}  </>}
                </div>
            </FormGroup>
        </Col>
    </Row>

    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        orientation={'vertical'}
    />
}

export default NotificationLangs